var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 3H7a3 3 0 0 0-3 3v14.382a1 1 0 0 0 1.447.894l6.134-3.067a1 1 0 0 1 .848-.021l6.17 2.7A1 1 0 0 0 20 19.97V5.995A2.996 2.996 0 0 0 17 3z",
    fill: "#672C78",
    stroke: "#672C78",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkOn);
export default __webpack_public_path__ + "static/media/bookmark_on.1e318caab98abbd4a368a560b2fd14bb.svg";
export { ForwardRef as ReactComponent };